import { createBrowserRouter } from "react-router-dom";
import routes, { loadAppointmentAction } from "./routes";
import { accountCreateChunk, signInChunk } from "../views/Book/lazySteps";
import { loadBookRecovery } from "../views/Book/recoveryChunk";
import { holdBoot } from "../i18n";
import { attachToRouter } from "../analytics/session";

// The browser router. The route table itself lives in routes.tsx so it can be
// mounted in a memory router under test.
//
// A FIRST URL UNDER /a starts the appointment page's chunk NOW, at entry
// evaluation, before the router renders: the link costs no extra round trip
// (Web Director, rc.9). The router's own lazy load gets the same promise. A
// failure is left to the router, which shows RouteError.
if (/^\/a(\/|$)/.test(window.location.pathname)) void loadAppointmentAction().catch(() => {});
// The same for a first URL on /book/create (rc.12 (a)): account creation's
// chunk starts with the entry. The step's own load gets the same promise, and
// a Spanish reader's boot waits for it (one skeleton, then the step).
if (/^\/[^/]+\/book\/create\/?$/.test(window.location.pathname)) holdBoot(accountCreateChunk.load()).catch(() => {});
// And the sign-in step's form (2026-10-28), likewise holding a Spanish boot.
if (/^\/[^/]+\/book\/signin\/?$/.test(window.location.pathname)) holdBoot(signInChunk.load()).catch(() => {});
// And for a first URL on the password reset (2026-10-28): its chunk starts
// with the entry, and the router's lazy load gets the same promise.
if (/^\/[^/]+\/book\/reset\/?$/.test(window.location.pathname)) void loadBookRecovery().catch(() => {});
const router = createBrowserRouter(routes);

// OPTIONAL ANALYTICS OBSERVES THE ROUTER; IT IS NOT IN THE ROUTE TABLE.
//
// Deliberate: a component that reads `useLocation` would have to be mounted
// inside each route or inside a new pathless layout route wrapping them all,
// and the second reshapes `routes` — which `index.test.tsx` guards, because
// every top-level path costs a name out of the slug space and booking links
// are printed on cards. Analytics is not a good enough reason to touch the
// routing contract.
//
// This call is a NO-OP in every committed configuration: the enable flag is
// absent, so `decide` refuses before anything is loaded. See
// analytics/gates.ts for the six things that must all agree first.
attachToRouter(router);

export default router;
